"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumbers = void 0;
const formatNumbers = (num) => num &&
    num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
exports.formatNumbers = formatNumbers;
